export default __webpack_public_path__ + "static/media/page10.872ff234.jpg";